import { Outlet, useLocation } from 'react-router-dom';

import { env, routes } from '@/shared/lib';
import { HStack } from '@/shared/ui';
import ChatWrapper from '@/shared/ui/chat/components/chat-wrapper/chat-wrapper';
import { AppSidebar } from '@/widgets/app-sidebar';
import { Header } from '@/widgets/header';

const showChat = env.VITE_SHOW_CHAT === 'true';

export const BaseLayout = () => {
  const location = useLocation();
  const isSystemPage =
    location.pathname === routes.MAIN ||
    location.pathname === routes.PROFILE ||
    location.pathname.includes(routes.COMPANY_MANAGEMENT) ||
    location.pathname.includes(routes.MEETING_GROUP) ||
    location.pathname.includes('/session/') ||
    location.pathname === routes.ACTIVE_CONVERSATIONS ||
    location.pathname === routes.TARIFFS ||
    location.pathname === routes.SUPPORT;

  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground transition-colors overflow-hidden">
      <HStack gap="24" className="flex-1 px-[1rem] pb-[1rem] min-h-0 items-stretch">
        <AppSidebar />
        <div
          className={`flex-1 min-w-0 flex flex-col min-h-0 ${isSystemPage ? 'h-[calc(100vh-2rem)]' : ''}`}
        >
          {!isSystemPage && <Header />}
          <div className="flex-1 min-h-0 overflow-auto">
            <Outlet />
          </div>
        </div>
      </HStack>
      {showChat && <ChatWrapper />}
    </div>
  );
};
